import LinkLoyaltyCard from './LinkLoyaltyCard';
export default LinkLoyaltyCard;
